// export * from './interface-layer';
// export { PassiveTrackerEventListener } from './passive-tracker-event-listener';
// // import { configStore } from './config-store';
// // Example usage
// // addTrackingConfig('userSettings', { theme: 'dark', notifications: true });
export * from "./global-functions"; // apply global function
import { init } from "./initialize-passive";
init();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/index.js
// module id = ./node_modules/@celine/passive-tracking/dist/index.js
// module chunks = 0